import axios from "axios";
import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";

const inputStyle = { width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0", borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff", outline: "none", transition: "border-color 0.2s", cursor: "pointer" };
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };
const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "left" };
const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0" };

const VoucherTypeMapping = () => {
  const [voucherTypes, setVoucherTypes] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedVoucherType, setSelectedVoucherType] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [mappings, setMappings] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentMappingId, setCurrentMappingId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const { permissions } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const Config = Authorization();
        const [mappingsRes, typesRes, accountsRes] = await Promise.all([
          axios.get(`${Api}/api/voucher-type-mappings`, Config),
          axios.get(`${Api}/api/voucher-types`, Config),
          axios.get(`${Api}/api/accounts`, Config),
        ]);
        setMappings(mappingsRes.data.voucherTypeMappings);
        setVoucherTypes(typesRes.data.voucherTypes);
        setAccounts(accountsRes.data.data);
      } catch (error) {
        console.error("Error fetching voucher data", error);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const newMapping = { voucherType: selectedVoucherType, accountId: selectedAccountId };

    try {
      const Config = Authorization();
      if (isEditing) {
        const response = await axios.put(`${Api}/api/voucher-type-mappings/${currentMappingId}`, newMapping, Config);
        setMappings(mappings.map((m) => m._id === currentMappingId ? response.data.voucherTypeMapping : m));
        setIsEditing(false);
      } else {
        const response = await axios.post(`${Api}/api/voucher-type-mappings`, newMapping, Config);
        setMappings([...mappings, response.data.voucherTypeMapping]);
      }
      handleCloseModal();
    } catch (error) {
      console.error("Error saving mapping", error);
    }
    setSubmitting(false);
  };

  const handleDeleteVoucherType = async (id) => {
    if (!window.confirm("Are you sure you want to delete this mapping?")) return;
    try {
      const response = await axios.delete(`${Api}/api/voucher-type-mappings/${id}`);
      setMappings(response.data.voucherTypeMappings);
    } catch (error) {
      console.error("Error deleting mapping", error);
    }
  };

  const handleEditClick = (mapping) => {
    setSelectedVoucherType(mapping.voucherType._id);
    setSelectedAccountId(mapping.accountId._id);
    setCurrentMappingId(mapping._id);
    setIsEditing(true);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEditing(false);
    setSelectedVoucherType("");
    setSelectedAccountId("");
    setCurrentMappingId(null);
  };

  const focus = (e) => (e.target.style.borderColor = "#4CAF50");
  const blur = (e) => (e.target.style.borderColor = "#E2E8F0");

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Voucher Type Mapping</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>Vouchers</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Voucher Type Mappings</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-swap-horizontal" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Mapping List</span>
          <span style={{ padding: "3px 10px", background: "rgba(255,255,255,0.2)", borderRadius: 20, fontSize: 11, color: "#fff", fontWeight: 600 }}>
            {mappings.length} Records
          </span>
          {permissions.includes("AddVoucherTypeMappings") && (
            <button onClick={() => setShowModal(true)}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 14px", background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              <i className="mdi mdi-plus" /> Add Mapping
            </button>
          )}
        </div>

        <div style={{ padding: 16, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Voucher Type</th>
                <th style={thStyle}>Account</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {mappings.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ ...tdStyle, textAlign: "center", color: "#A0AEC0", padding: "40px" }}>No mappings found.</td>
                </tr>
              ) : (
                mappings.map((mapping, index) => (
                  <tr key={mapping._id || index} style={{ background: index % 2 === 0 ? "#fff" : "#F7FAFC" }}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={{ ...tdStyle, fontWeight: 600, color: "#2D3748" }}>{mapping.voucherType.voucherName}</td>
                    <td style={tdStyle}>{mapping.accountId.accountName}</td>
                    <td style={tdStyle}>
                      <i className="mdi mdi-pen" style={{ fontSize: "1.4rem", cursor: "pointer", marginRight: 8, color: "#2E7D32" }}
                        onClick={() => handleEditClick(mapping)} />
                      <i className="mdi mdi-delete" style={{ fontSize: "1.4rem", cursor: "pointer", color: "#E53E3E" }}
                        onClick={() => handleDeleteVoucherType(mapping._id)} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Inline Modal ── */}
      {showModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#fff", borderRadius: 12, width: "100%", maxWidth: 480, boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>
                {isEditing ? "Edit Mapping" : "Add New Mapping"}
              </span>
              <button onClick={handleCloseModal} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: 6, color: "#fff", cursor: "pointer", fontSize: 16, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
            </div>
            <div style={{ padding: 24 }}>
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                  <label style={labelStyle}>Voucher Type <span style={{ color: "#E53E3E" }}>*</span></label>
                  <select value={selectedVoucherType} onChange={(e) => setSelectedVoucherType(e.target.value)} required
                    style={inputStyle} onFocus={focus} onBlur={blur}>
                    <option value="">Select Voucher Type</option>
                    {voucherTypes.map((type) => (
                      <option key={type._id} value={type._id}>{type.voucherName}</option>
                    ))}
                  </select>
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={labelStyle}>Account <span style={{ color: "#E53E3E" }}>*</span></label>
                  <select value={selectedAccountId} onChange={(e) => setSelectedAccountId(e.target.value)} required
                    style={inputStyle} onFocus={focus} onBlur={blur}>
                    <option value="">Select Account</option>
                    {accounts.map((account) => (
                      <option key={account._id} value={account._id}>{account.accountName}</option>
                    ))}
                  </select>
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <button type="submit" disabled={submitting}
                    style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "10px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: submitting ? "not-allowed" : "pointer", boxShadow: "0 3px 10px rgba(46,125,50,0.3)", opacity: submitting ? 0.7 : 1 }}>
                    <i className="mdi mdi-check" /> {submitting ? "Saving..." : isEditing ? "Update" : "Submit"}
                  </button>
                  <button type="button" onClick={handleCloseModal}
                    style={{ padding: "10px 20px", background: "#F7FAFC", color: "#4A5568", border: "1px solid #E2E8F0", borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VoucherTypeMapping;
